import toast from "react-hot-toast";
import { useFileUploads } from "../api/useProducts/useFileUpload";

const useMultipleFileUpload = () => {
  const { mutate: singleFileUpload, isPending: isMultipleUploading } =
    useFileUploads(); // Use `FormData` as the input type here

  const MultipleUploadImages = async (imageFiles: File[]): Promise<any> => {
    if (!imageFiles || imageFiles.length === 0) {
      toast.error("No files selected");
      return null;
    }
    // Create a FormData instance
    const formData = new FormData();
    imageFiles.forEach((file, index) => {
      formData.append(`files`, file); // Use `files` as the key for multiple files
    });

    formData.append("directory", "general"); // Append the directory

    return new Promise((resolve, reject) => {
      // @ts-ignore
      singleFileUpload(formData, {
        onSuccess: (res: any) => {
          const imageUrls = res.map((item: any) => item.url);
          resolve(imageUrls);
        },
        onError: (error: any) => {
          const errorMessage =
            error.response?.data?.message || "Image upload failed";
          toast.error(errorMessage);
          reject(error);
        },
      });
    });
  };

  return { MultipleUploadImages, isMultipleUploading };
};

export default useMultipleFileUpload;
